<template>
  <teleport to="body">
    <transition name="fade">
      <div v-if="visible" class="fancy-toast-overlay" @click.stop>
        <div class="fancy-toast-card">
          <div class="fancy-toast-icon" v-if="icon">
            <img :src="icon" alt="" />
          </div>
          <div class="fancy-toast-title">{{ title }}</div>
          <div class="fancy-toast-sub" v-if="subtitle">{{ subtitle }}</div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'

interface Props {
  title: string
  subtitle?: string
  icon?: string
  duration?: number
}

const props = withDefaults(defineProps<Props>(), {
  title: 'Success',
  subtitle: '',
  icon: '',
  duration: 113000
})

const visible = ref(true)
let timer: number | null = null

onMounted(() => {
  timer = window.setTimeout(() => {
    visible.value = false
  }, Number(props.duration))
})

onBeforeUnmount(() => {
  if (timer) window.clearTimeout(timer)
})
</script>

<style scoped lang="scss">
.fancy-toast-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.25);
  
}

.fancy-toast-card {
  width: 220px;
  border-radius: 20px;
  padding: 24px;
  // background: linear-gradient(180deg, #2a2e52 0%, #1b1e3a 100%);
  background: rgba(141,143,168,0.15);
  box-shadow: 0 10px 24px rgba(0,0,0,0.35);
  // background: rgba(141,143,168,0.15);
  backdrop-filter: blur(43px);
  -webkit-backdrop-filter: blur(43px);
  text-align: center;
  color: #fff;
}

.fancy-toast-icon {
  width: 120px;
  height: 120px;
  margin: 0 auto 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  img { width: 100%; height: 100%; object-fit: contain; }
  margin-bottom: 0;
}

.fancy-toast-title {
  font-weight: 900;
  // font-size: 18px;
  font-size: 16px;
  color: #FFFFFF;
}

.fancy-toast-sub {
  margin-top: 6px;
  font-size: 12px;
  color: rgba(255,255,255,0.7);
  font-size: 12px;
}

.fade-enter-active, .fade-leave-active { transition: opacity .2s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>


